import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import HUlabel1 from './../workinstructions/images/HUlabel1.png';
import HUlabel2 from './../workinstructions/images/HUlabel2.png';
import NokiaSeal from './../workinstructions/images/nokiaseal.png';
import ShipmentNoRegistration from './../workinstructions/images/shipmentnoregistration.png';
import ZLAB from './../workinstructions/images/ZLAB.png';
import ZT01 from './../workinstructions/images/ZT01.png';
import ZT02 from './../workinstructions/images/ZT02.png';
import ZZETES00 from './../workinstructions/images/ZZETES00.png';
import SU3defaults from './../workinstructions/images/SU3defaults.png';
import SU3parameters from './../workinstructions/images/SU3parameters.png';
import ME23N from './../workinstructions/images/ME23N.png';
import VT01N from './../workinstructions/images/VT01N.png';
import HUMOserial from './../workinstructions/images/HUMOserial.png';
import ZLAC from './../workinstructions/images/ZLAC.png';
import HUMO from './../workinstructions/images/HUMO.png';
import VT02N from './../workinstructions/images/VT02N.png';
import ZZETES0041cyclecount from './../workinstructions/images/ZZETES00-4-1-cyclecount.png';
import ZT02AWBcheck from './../workinstructions/images/ZT02-AWB-check.png';

class ALUInbound extends React.Component {
    
    componentDidMount() {
	    document.title = "ALU Inbound";        
        // Check if there's a hash in the URL and scroll to that section
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1); // Remove the # from hash
            setTimeout(() => {
                const element = document.getElementById(targetId);
                if (element) {
                    // Calculate scroll position with offset to show the heading properly
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - 100; // Adjust this value as needed
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }

    render() {
        return (
            <div>

                <h1 className="page-header">Inbound-Operations of MN-NI</h1>
                <Panel>
                    <PanelHeader>ALU-Inbound</PanelHeader>
                    <PanelBody>
                    <h2>Printer configuration</h2>
                        <p>
                            Use ST SU3 =&gt; go to tab Defaults =&gt; go to Output Device and fill in printername "NLZEB01/02/03" =&gt; save
                        </p>
	                       <p> <img src={SU3defaults} alt="SU3-defaults" style={{ maxWidth: '100%', height: 'auto' }} /> </p>			
	                       <p> <img src={SU3parameters} alt="SU3-parameters" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
	
                        <h2>Transport registration</h2>
                        <p>
                            Use ST ZT01.<br />
	                       <p> <img src={ZT01} alt="ZT01 ShipmentNo Registration" style={{ maxWidth: '100%', height: 'auto' }} /> </p>			
                            Look into the shipmentpaper if there is sales-order starting with 4500. If yes, then it is Newbuy<br />
                            If the items with "status" on the label of item, then it is Repaired<br />
                            When it is Newbuy, then type in NBY for item batch.<br />
                            Look into list of RVS (https://wappsolute.com/ERP/RVSs). If the name of RVS is not in the list, then type in INC, other FOU and fill in the corresponding CodeNr<br />
                            Fill in Shippername :"DHL/UPS/DPD" =&gt; in shipment-doc fill AWB<br />
                            fill in amount of colli/pallet =&gt; fill in weight=&gt; save<br />
                            Quality =[AB=packages damage, AU=other, EX=Package surplus, MQ=packages missed, ST=packages without T1]<br />
	                       <p> <img src={ShipmentNoRegistration} alt="ShipmentNo Registration" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
 
                            * if the shipment is incomplete, fill in the received quantities for example 3/4 , which means 3 of 4 collis are received
                        </p>
                        <h2>HU-label</h2>
                        <p>
                        <p> <img src={ZLAB} alt="ZLAB HU2 Label printing" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
                            Printed out label has a unique HU-nr, if it is starting with 503, then put the item on trollley 503<br />
                            for other cases look to the Zone, A/B/C/D/503 and put them on the corresponding trolleys
                        </p>
	     			    <p> <img src={HUlabel1} alt="HU2 Label" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
                        <p> <img src={HUlabel2} alt="HU2 Label" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
    
                        <h2>Goods Receiving Inbound Transfer from Ceva-Hu ZZETES00-1-1-4</h2>
                        <p>
                            Normally this will be used for items from Ceva Hungary.<br />
                            Use ZZETES00 =&gt; select 1 =&gt; select 1 =&gt; select 4 =&gt; enter shipment/transport-nr =&gt; insert HU2-nr and press enter =&gt; a label will be printed out on zebra-printer delivery always starting 800....<br />
                            If the items are scrapped, then confirm them in LT27 (fill in HU) =&gt; click on ..=&gt; stick label scrap on the item and put on pallet of SCRAP
                        </p>
                        <h2 id="ZZETES00-1-1-2">Goods receiving Repair Vendor ZZETES00-1-1-2</h2>
                        <p>
                        <p> <img src={ZZETES00} alt="ZZETES00 to receiving goods" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
                            Use ZZETES00 =&gt; select 1= &gt; select 1 =&gt; select 2 =&gt; insert shipment/transport-nr press enter =&gt; <br />
                            enter the material-code (if there is a batch-nr available insert in the same field of material nr) press enter <br />
                            =&gt; select version from pop-up-menu =&gt; enter serial press enter =&gt; select repair-code &#123;R=repaired, B=burned=scrap&#125; <br />
                            =&gt; In case of different serials insert tracking-nr and press enter =&gt; repair-code for different serials = EXC.<br />
                            =&gt; item is ready for put-away HU-nr starting with 503= direct to stock, 002=type E. Starting with 100,18,19 directed <br />
                            to 001-stock, not repaired/WRC HU:503, type 008 wrong repair center internal transfer to Hungary. 006 is SCRAP.<br />
                            We have status : R,RD,MR,Certified Pas=N, NTF, M,EXC
                        </p>	
                        <p> <img src={HUlabel1} alt="HU1 Label" style={{ maxWidth: '100%', height: 'auto' }} /> </p>    
                        <h2 id="ZZETES00-1-1-6">Goods Fast Receiving from Repair Vendor ZZETES00-1-1-6</h2>
                        <p>
                            Use ZZETES00 =&gt; select 1= &gt; select 1 =&gt; select 6 =&gt; insert shipment/transport-nr press enter =&gt; <br />
                            enter the material-code (if there is a batch-nr available insert in the same field of material nr) press enter <br />
                            =&gt; select version from pop-up-menu =&gt; enter serial press enter =&gt; select repair-code &#123;R=repaired, B=burned=scrap&#125; <br />
                            =&gt; In case of different serials insert tracking-nr and press enter =&gt; repair-code for different serials = EXC.<br />
                            =&gt; item is ready for put-away HU-nr starting with 503= direct to stock, 002=type E. Starting with 100,18,19 directed <br />
                            to 001-stock, not repaired/WRC HU:503, type 008 wrong repair center internal transfer to Hungary. 006 is SCRAP.
                        </p>	
    
                        <h2>Goods receiving SWAP serial nr</h2>
                        <p>
                            Use ZZETES00 =&gt; select 1 =&gt; select 1=&gt; select 2 (Gr Repair C) =&gt; enter shipment/transport-nr<br />
                            =&gt; enter material-nr (insert batch-nr when it is available)=&gt; select version from pop-up-menu<br />
                            =&gt; insert serial-nr =&gt; insert customer-reference-nr (from paper-form)=&gt; insert for repair-code EXC
                        </p>
                        <p>
                        If the trackingnumber is not on the item or visible  =&gt;  use ME23N =&gt; fill in PO-number =&gt;  Go to or click on header detail =&gt;
                        select the right material-code from the dropdownlist =&gt; Look to "confirmations" =&gt; copy the trackingnumber from here	
                        </p>
                        <h2 id="ZZETES00-1-1-3">Goods receiving New Parts 4500/2900/5011 ZZETES00-1-1-3</h2>
                        <p>
                            ZZETES00 =&gt; select 1=&gt; select 1 =&gt; select 3 (GR supplier) =&gt; insert shipment/transport-nr <br />
                            =&gt; insert PO-nr =&gt; insert material-code =&gt; select version from pop-up-menu =&gt; insert serial-nr<br />
                            =&gt; overview of booking=&gt; enter =&gt; label met HU will be printed out PO starts with 45000, but if PO starts with 29000 or 501, then look in the list of that week and write down the belongings 45000
                        </p>
                        <h2>Inbound Customer/ DOA/RLC</h2>
                        <p>
                            Use ZVA02N =&gt; insert RMA/Sales order / serial -nr and press execute =&gt; insert transport/shipment-nr press enter =&gt;insert material-code with version, serial press enter <br />
                            =&gt; Press button SCAN for each item to book. When all items are scanned =&gt; press “end of package" (Shift+F1) =&gt; select save and make delivery =&gt; items are booked to 005 or 008
                        </p>
                        <h2>Internal transfer 008 to ceva HU </h2>
                        <p>
                            3-3-1: recipient code= RLC-HU-BAT, scan HU-nr in, enter measurements, enter, get the shippingpaper from printer at ASV =&gt; always ship out with Economic 
                        </p>
                        <h2>Creating new serial</h2>
                        <p>
                            Country-code, Year Weeknumber then 001,002,003,…..for example NL202404001, NL202404002 etc
                        </p>
                        <h2>Change Serial</h2>
                        <p>
                            Use HUMO =&gt; scan in the HU-nr of the label =&gt; F8 =&gt; click on edit-icon =&gt; F3 =&gt; go to Pack Material =&gt; click on Hu-nr =&gt; scan new serial in to overwrite the old one at HU Identification 2-field=&gt; save<br />
                            got to ZALB =&gt; scan HU-nr in =&gt; Save
                        </p>
                        <h2>Change Batch after receiving</h2>
                        <p>
                            Use LT27 =&gt; scan in the material-code =&gt; confirm the item =&gt; start VLMOVE =&gt; select 309 =&gt; transfer material to material =&gt; insert HU-nr in handling unit <br />
                            =&gt; Enter=&gt;select tab Material . scroll to right. Go to stkTrnsfrBat-veld. Vul nieuwe batch in. =&gt; click on post goods movements. <br />
                            print new label with ZALAB vul in HU-nr. select 2nd option for printout
                        </p>
                        <h2>Create PO 45XXXX voor new items/retrofit</h2>
                        <p>
                            USe ME23N =&gt; select standard PO =&gt; for vendor: insert system-code from paperwork / CSLITGHU =&gt; 
                        <p> <img src={ME23N} alt="ME23N" style={{ maxWidth: '100%', height: 'auto' }} /> </p>    
                            =&gt; in vendor-field : select the correct vendor =&gt; ENTER =&gt; go to Tab Communication =&gt; select status of item NOT NEW =&gt;
                            go to Tab ORg. data : purch org= HT01, purch group = SP1, companycode = automatic filled =&gt; fill in for material , quantity, net price (=0,01), currency , plant storage location press enter =&gt; 
                            select check (if everything has been inserted correct you will get message "no messages issued during check" =&gt; save =&gt;  PO-nr created appears left-under of screen =&gt;    
                        </p>
                        <h2>Anomaly 3: 3rd Return</h2>
                        <p>
                          Start SQ01 =&gt; Go to Dispute 6 =&gt; F8 =&gt; emppty all fields =&gt; At date: start one year back till today  =&gt; When bigger or equal to 3 =&gt;
                          =&gt; Register in X-vak =&gt; When less than 3 =&gt; receiving with ligitation-nr, ligitation-nr is printd out on the label 
                        </p>
            
                        <h2>Deleting HU-label</h2>
                        <p>
                            Use HUMO =&gt; Scan HU-nr in =&gt; F8 =&gt; click on pencil-icon =&gt; go to material, select line =&gt; click on empty icon =&gt; 
                            click on select item again =&gt; click on delete-icon (delete handling unit) =&gt; F3 =&gt; SHIFT + F2 =&gt;
                            Yes or you can use VL32N
                        </p>
                        <h2>Looking for Tracking-number for booking of repaired items</h2>
                        <p>
                            Use ME23N =&gt; fill PO-nr in  and click on item detail =&gt; select the concerning material and serial from dropdownlist 
                            =&gt; Go to Tab "confirmation" =&gt; read the trackingnumber in field "Örder Acknowledgement"
                        </p>

                        <h2>Anamoly 5 Tracking or SPT N</h2>
                        <p>
                            Use ME23N =&gt; Shift+F5 to fill in PO =&gt; select material at dropdownlist at item =&gt; look to where it is 0 , under Quality Red =&gt;
                            click on inbound delivery-nr =&gt; click on edit =&gt; F3 =&gt; Go to Pack (Shift + F6) =&gt; 
                            click on Hu and scan serial in =&gt; Save 
                        </p>
                                
                        <h2>Anamoly 7: HU creating error</h2>
                        <p>
                            Use ME23N =&gt; Shift+F5 to fill in PO =&gt; select material at dropdownlist at item =&gt; look to where it is 0 , under Quality Red =&gt;
                            click on inbound delivery-nr =&gt; click on edit =&gt; F3 =&gt; Go to Pack (Shift + F6) =&gt; 
                            click on Hu and scan serial in =&gt; Save 
                        </p>
                        <p>
                            If there is no delivery in ME23N and in Pack you see empty fields =&gt; then you can delete the row and try to receiving again =&gt;
                        </p>

                        <h2>Changing the Batch in PO</h2>
                        <p>
                            Use ME23N =&gt; fill in the PO =&gt; go to the concerning material-code =&gt;
                        </p>
                        <h2>Create PO 45XXXX voor new items/retrofit</h2>
                        <p>
                            Use ME21N =&gt; at vendor type CSLITIGHU CUSTOMER LIGITATIONS =&gt; click on Header 
                            =&gt; Go to Tab Communication =&gt; select part "Not New" =&gt; Go to Org Data purch org select HNL1 at purch group select SP1 
                            =&gt; Enter =&gt; Fill material-code without batch in, PO quantity (1), Net Price (=0,01), Plnt (C100), Stor. Location (NP01) 
                            At communications  conf control : Inbound el Alca =&gt; for checking if errors CRTL +SHIFT +F3 =&gt; Save =&gt;
                        </p>
                        <h2>Checking if AWB has been registered</h2>
                        <p>
                            Use ZT02 =&gt; Click on small window =&gt; go to field BLIVR and scan the AWB in =&gt; Enter
                        </p>
                        <h2>Put-away Export</h2>
                        <p>
                            Use handscanner =&gt; login (georgia,georgia) =&gt; login SAP  =&gt; choose  3-1-2 =&gt; Scan delivery-nr =&gt; Scan HU2-code =&gt; Scan stocklocation
                        </p>                            
                        <h2>Anomaly 3: Evol allocated item no allowed</h2>
                        <p>
                            start ME23N =&gt; Shift F5 =&gt; F7 =&gt;  ooking for the wanted serial =&gt; Go to atb "Confirmations"=&gt; go to Con.Control =&gt; select Inbound Del Alcatel =&gt; Save
                        </p>                                                        
           			    <h2>Cycle Counting ZZETES00-4-1</h2>
                        <p>
                            Use ZZETES00 =&gt; go to 4-1 =&gt; fill in de document number and use handscanner to scan stock-location and then the HUs =&gt; press F1 after finishe counting at location
                        </p>
	                       <p> <img src={ZZETES0041cyclecount} alt="ZZETES00-4-1-cyclecount" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
								
                    </PanelBody>
                    <footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
                      <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
                        &copy; Nov 2025 by TQT Tong. All rights reserved.
                      </p>
                    </footer>
                            
                </Panel>
        
            </div>
        )
    }
}

export default ALUInbound;







































